import { render, staticRenderFns } from "./EditSalesInvoiceComponent.vue?vue&type=template&id=3505f983&"
import script from "./EditSalesInvoiceComponent.vue?vue&type=script&lang=js&"
export * from "./EditSalesInvoiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports